export default "__VITE_ASSET__js65iJZA__"